import BuyerFeatureIcon from '../../../Component/UI/BuyerFeatureIcon';
import SellerGiftList from '../../../Component/UI/SellerGiftList';
import { groupCancellationHistory } from '../../../Component/tool/groupCancellationHistory';
import CancelTicketLetter from '../Live/modal/CancelTicketLetter';
import MyInfoModal from '../Home/Component/MyInfoModal';
import BillRefundAccount from './BillRefundAccount';
import BillDeliveryStatuses, { latestDeliveryStatus } from './BillDeliveryStatuses';
import { matchesPurchase, purchaseClaimInfo } from './billPurchaseClaims';
/* eslint-disable react/jsx-pascal-case */
import { StatePage } from "../../../Component/UI/ContentState";
import axios, { AxiosError } from "axios";
import { useEffect, useLayoutEffect, useState, useMemo, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import api from "../../../Component/axios_Interceptor/api";
import { launchCardPayment, launchHFPayment, launchReceipt } from "../../../Component/payment/hecto";
import { isStatementPaid, isPgPaid, paymentRequest, PaymentMethod, PaymentSummary, paymentModeLabel, paymentDate, validPaymentSummary, BUYER_PAYMENT_LOGIN_MESSAGE } from "../../../Component/payment/statement";
import url, { SERVER_ADDRESS } from "../../../Component/server";
import { fontStyles } from "../../../Component/style/common_font";
import { CenterView, RowView, Icon } from "../../../Component/style/common_style";
import Layout_user from "../../../Component/UI/Layout_user";
import SearchAddrApi from "../Sign/Modal/SearchAddrApi";
import { carrierTrackingLink } from "../../../Component/tool/carrierTracking";
import ProductDeliverySection from "../../../Component/UI/ProductDeliverySection";

const billAuth = { handleAuthErrorLocally: true };
const needsLogin = (error: any) => error?.code === 'AUTH_REQUIRED' || error?.response?.status === 401;

interface InfoList {
  seq?: number;
  product_seq?: number;
  product_price?: number;
  cancel_price?: number;
  individual_delivery?: boolean | number;
  individual_delivery_price?: number;
  cancel_cnt?: number;
  coupon_discount_amount?: number;
  net_product_amount?: number;
  option_name: null | string;
  order_cnt: number;
  order_price: number;
  order_status: string;
  status_update_dt?: string;
  product_name: string;
  payment_method?: 'pg' | 'bank';
  cancellation_source?: 'admin' | 'customer' | null;
  courier?: string | null;
  tracking_number?: string | null;
}

const User_Bill = () => {
  const { uid } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const combinedPreview = process.env.NODE_ENV === 'development' && new URLSearchParams(location.search).get('preview') === 'combined';
  const [profileEditOpen, setProfileEditOpen] = useState(false);
  const [profileEditSection, setProfileEditSection] = useState<"profile" | "refund">("profile");
  const [refundAccountRefresh, setRefundAccountRefresh] = useState(0);
  const [loginRequired, setLoginRequired] = useState(false);
  const loginUrl = new URL(url.Communication_url.kakao_login, window.location.origin);
  loginUrl.searchParams.set('nextPath', location.pathname + location.search + location.hash);
  const requestLogin = (error: unknown) => {
    if (!needsLogin(error)) return false;
    statementRequest.current += 1;
    setLoginRequired(true);
    setStatement(null);
    setList([]);
    setIsConfirmPayOpen(false);
    setIsFailPayOpen(false);
    return true;
  };
  const [statement, setStatement] = useState<any>(null);
  const [deliveryRefreshKey, setDeliveryRefreshKey] = useState(0);
  const billTopRef = useRef<HTMLDivElement>(null);
  const agreementRef = useRef<HTMLDivElement>(null);
  const agreeAllRef = useRef<HTMLInputElement>(null);
  const statementLoaded = Boolean(statement);
  useLayoutEffect(() => {
    if (!statementLoaded) return;
    const target = window.location.hash.slice(1);
    const section = ['bank-info', 'shipping'].includes(target) ? document.getElementById(target) : null;
    (section ?? billTopRef.current)?.scrollIntoView?.({ block: 'start' });
  }, [uid, statementLoaded]);
  const inquiryStoreSeq = Number(statement?.store_seq);
  const sellerInquiry = Number.isSafeInteger(inquiryStoreSeq) && inquiryStoreSeq > 0 ? (
    <SellerInquiryButton as="button" type="button" onClick={() => navigate(`/store/${inquiryStoreSeq}/inquiry${statement?.is_gift_only ? '' : `?orderSeq=${uid}`}`)}>
      <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.5 8.5 0 0 1-8.5 8.5H4l-1 1v-9.5a8.5 8.5 0 0 1 17 0Z" /><path d="M8 10h8M8 14h5" /></svg>문의하기
    </SellerInquiryButton>
  ) : null;
  const paymentSummary: PaymentSummary | undefined = statement?.payment_summary;
  const statementRequest = useRef(0);
  const [loadError, setLoadError] = useState("");
  const [paymentError, setPaymentError] = useState("");
  const [paymentBusy, setPaymentBusy] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethod>('card');
  const [receiptBusy, setReceiptBusy] = useState(false);
  const [receiptError, setReceiptError] = useState('');
  const [paymentReviewBusy, setPaymentReviewBusy] = useState(false);
  const [paymentReviewError, setPaymentReviewError] = useState('');
  const reviewingPayment = useRef(false);
  const receipting = useRef(false);
  const [savingAddress, setSavingAddress] = useState(false);
  const [shippingRegionBusy, setShippingRegionBusy] = useState(false);
  const [shippingRegionError, setShippingRegionError] = useState('');
  const paying = useRef(false);
  const saving = useRef(false);
  const activeUid = useRef(uid);
  activeUid.current = uid;
  const paymentReturn = new URLSearchParams(location.search).get("payment");

  const openReceipt = async () => {
    if (receipting.current || !uid) return;
    receipting.current = true; setReceiptBusy(true); setReceiptError('');
    try {
      const { data } = await api.get(url.Communication_url.payment_receipt, { ...billAuth, params: { orderSeq: Number(uid) } });
      if (activeUid.current === uid) await launchReceipt(data);
    } catch (failure: any) {
      if (activeUid.current !== uid || requestLogin(failure)) return;
      setReceiptError(failure?.response?.data?.message || failure?.message || '영수증 조회 정보를 불러오지 못했습니다.');
    } finally { receipting.current = false; setReceiptBusy(false); }
  };

  // 배송지 원본 및 수정용 상태 관리
  const [recipient, set_Recipient] = useState("");
  const [phone, set_Phone] = useState("");
  const [postCode, setPostCode] = useState("");
  const [firAddr, setFirAddr] = useState("");
  const [secAddr, setSecAddr] = useState("");
  const [requestNote, setRequestNote] = useState("");
  const [isEditingRequestNote, setIsEditingRequestNote] = useState(false);
  const [draftRequestNote, setDraftRequestNote] = useState("");
  const [savingRequestNote, setSavingRequestNote] = useState(false);
  const [requestNoteError, setRequestNoteError] = useState("");
  const [requestNoteSaved, setRequestNoteSaved] = useState(false);
  const requestNoteSaving = useRef(false);

  // 임시 수정용 상태
  const [tempRecipient, setTempRecipient] = useState("");
  const [tempPhone, setTempPhone] = useState("");
  const [tempPostCode, setTempPostCode] = useState("");
  const [tempFirAddr, setTempFirAddr] = useState("");
  const [tempSecAddr, setTempSecAddr] = useState("");
  const [tempRequestNote, setTempRequestNote] = useState("");

  const [list, setList] = useState<InfoList[]>([]);
  const [cancelRefund, setCancelRefund] = useState(0);
  const [purchase, setPurchase] = useState(0);
  const [totalPayment, setTotalPayment] = useState(0);
  const [hasSellerGifts, setHasSellerGifts] = useState(false);
  useEffect(() => { setHasSellerGifts(false); }, [uid]);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [delivery_price, setDelivery_price] = useState(0);

  // 화면 전환 및 결제 상태 분기 관리
  const [isEditingAddress, setIsEditingAddress] = useState(false);
  const addressPromptedFor = useRef<string | null>(null);
  const [isPaid, setIsPaid] = useState(false);
  const [isViewingDetail, setIsViewingDetail] = useState(() => new URLSearchParams(location.search).get('view') === 'purchases');


  // 이용약관 동의 상태
  const [agreementAttention, setAgreementAttention] = useState(false);
  const [agree1, setAgree1] = useState(false);
  const [agree2, setAgree2] = useState(false);
  const [agree3, setAgree3] = useState(false);

  // 팝업 상태들
  const [isConfirmPayOpen, setIsConfirmPayOpen] = useState(false);
  const [isSuccessPayOpen, setIsSuccessPayOpen] = useState(false);
  const [isFailPayOpen, setIsFailPayOpen] = useState(false);

  // 송장 복사 팝업 상태
  const [isCopyModalOpen, setIsCopyModalOpen] = useState(false);
  const [selectedTracking, setSelectedTracking] = useState<{ carrier: string; trackNum: string } | null>(null);

  // 품목별 실제 택배사와 송장번호를 중복 없이 표시한다.
  const trackingList = useMemo(() => {
    const fromApi = list
      .filter((item) => item.tracking_number && item.courier)
      .map((item) => ({ carrier: item.courier!, trackNum: item.tracking_number! }));
    const unique = Array.from(
      new Map(fromApi.map((t) => [`${t.carrier}_${t.trackNum}`, t])).values()
    );
    return unique;
  }, [list]);

  const productDeliverySection = statement?.is_order_owner === true && list.some(item =>
    (item.individual_delivery === true || item.individual_delivery === 1)
      && !['주문취소', '환불처리', '사고처리'].includes(item.order_status)
      && Number(item.order_cnt) > Number(item.cancel_cnt || 0))
    ? <ProductDeliverySection orderSeq={Number(uid)} refreshKey={deliveryRefreshKey} /> : null;
  const sellerGiftSection = statement?.is_order_owner === true ? <SellerGiftList orderSeq={Number(uid)} refreshKey={deliveryRefreshKey} customer autoRefresh={isViewingDetail} hideWhenEmpty onLoaded={items => setHasSellerGifts(items.length > 0)} /> : null;
  const giftOnlyPurchase = statement?.is_gift_only === true || (hasSellerGifts && totalPayment === 0 && !list.some(item => !['주문취소', '환불처리', '사고처리'].includes(item.order_status) && Number(item.order_cnt) > Number(item.cancel_cnt || 0)));

  const shippingPolicyText = useMemo(() => {
    if (!statement) return '';
    if (statement.shipping_mode === 'free') return '이 방송은 무료배송입니다.';
    const activeShippingDetails = (statement.details || []).filter((detail: any) => !['주문취소', '환불처리', '사고처리'].includes(detail.order_status) && Number(detail.order_cnt) > Number(detail.cancel_cnt || 0));
    if (activeShippingDetails.length > 0 && activeShippingDetails.every((detail: any) => detail.individual_delivery)) return '개별 배송 상품의 배송비는 0원입니다.';
    const threshold = statement.shipping_mode === 'fixed' ? 0 : Number(statement.free_shipping_threshold ?? 0);
    const regionLabel = statement.shipping_region === 'jeju' ? '제주도' : statement.shipping_region === 'remote' ? '도서산간' : '일반';
    if (threshold > 0) {
      return delivery_price === 0
        ? `상품금액 ${threshold.toLocaleString()}원 이상 구매하여 무료배송이 적용되었습니다. (${regionLabel})`
        : `${regionLabel} 배송 · 상품금액 ${threshold.toLocaleString()}원 이상 무료배송 · 적용 배송비 ${delivery_price.toLocaleString()}원`;
    }
    return `${regionLabel} 배송비 ${delivery_price.toLocaleString()}원`;
  }, [statement, delivery_price]);

  const get_statement_info = async () => {
    const request = ++statementRequest.current;
    if (!uid || !Number.isSafeInteger(Number(uid)) || Number(uid) <= 0) {
      setLoadError("올바른 정산서 주소가 아닙니다.");
      return null;
    }
    try {
      const { data } = await api.get(url.Communication_url.statement_info, {
        ...billAuth,
        params: { order_seq: Number(uid) },
      });
      if (activeUid.current !== uid || request !== statementRequest.current) return null;
      if (data?.payment_summary != null && !validPaymentSummary(data.payment_summary)) throw new Error('Invalid payment summary');
      setLoginRequired(false);
      const previewDetails = combinedPreview ? (data.details || []).map((detail: any, index: number) => ({ ...detail, payment_method: index === 0 ? 'pg' : 'bank' })) : null;
      const previewPg = previewDetails?.filter((detail: any) => detail.payment_method === 'pg').reduce((sum: number, detail: any) => sum + Number(detail.net_product_amount ?? detail.order_price), 0) || 0;
      const previewBank = previewDetails?.filter((detail: any) => detail.payment_method === 'bank').reduce((sum: number, detail: any) => sum + Number(detail.net_product_amount ?? detail.order_price), 0) || 0;
      setStatement(combinedPreview ? { ...data, details: previewDetails, can_edit_address: false, can_edit_request_memo: false, is_order_owner: false,
        payment_summary: { ...data.payment_summary, payment_mode: 'combined', pg_amount: previewPg, bank_amount: previewBank,
          pg_due_amount: previewPg, bank_due_amount: previewBank, pg_paid: false, bank_paid: false, bank_account: null } } : data);
      setList(previewDetails || data.details || []);
      setDeliveryRefreshKey(value => value + 1);
      setCancelRefund(Number(data.cancelRefund || 0));
      setPurchase(Number(data.purchase || 0));
      setTotalPayment(Number(data.totalPayment || 0));
      setDiscountAmount(Number(data.discount_amount || 0));
      setDelivery_price(Number(data.delivery_price || 0));
      setIsPaid(!combinedPreview && isStatementPaid(data));
      set_Recipient(data.addr_recipient || "");
      set_Phone(data.addr_phone || "");
      setPostCode(data.addr_num || "");
      setFirAddr(data.addr_basic || "");
      setSecAddr(data.addr_detail || "");
      setRequestNote(data.request_memo || "");
      if (data.can_edit_address === true && addressPromptedFor.current !== uid
        && [data.addr_recipient, data.addr_phone, data.addr_num, data.addr_basic].some(value => !value?.trim())) {
        addressPromptedFor.current = uid;
        setTempRecipient(data.addr_recipient || "");
        setTempPhone(data.addr_phone || "");
        setTempPostCode(data.addr_num || "");
        setTempFirAddr(data.addr_basic || "");
        setTempSecAddr(data.addr_detail || "");
        setTempRequestNote(data.request_memo || "");
        setIsEditingAddress(true);
      }
      setLoadError("");
      return data;
    } catch (error) {
      if (activeUid.current !== uid || request !== statementRequest.current) return null;
      setStatement(null);
      setList([]);
      if (requestLogin(error)) return null;
      setLoadError("정산서를 불러오지 못했습니다. 주소와 연결 상태를 확인해주세요.");
      return null;
    }
  };

  const reviewPayment = async () => {
    if (!uid || reviewingPayment.current) return;
    const currentUid = uid;
    reviewingPayment.current = true; setPaymentReviewBusy(true); setPaymentReviewError('');
    try {
      await api.post(`${SERVER_ADDRESS}payment/card-review`, null, { ...billAuth, params: { orderSeq: Number(uid) }, timeout: 25000 });
      if (activeUid.current === currentUid) await get_statement_info();
    } catch (failure: any) {
      if (activeUid.current === currentUid && !requestLogin(failure)) setPaymentReviewError(failure?.response?.data?.message || '결제 승인 결과를 확인하지 못했습니다. 추가 결제 없이 다시 확인해주세요.');
    } finally { reviewingPayment.current = false; if (activeUid.current === currentUid) setPaymentReviewBusy(false); }
  };

  const toggleRemoteShipping = async () => {
    if (!uid || shippingRegionBusy || statement?.can_edit_address !== true || statement?.shipping_region === 'jeju') return;
    setShippingRegionBusy(true); setShippingRegionError('');
    try {
      await api.patch(url.Communication_url.order_shipping_region, {
        order_seq: Number(uid), shipping_region: statement.shipping_region === 'remote' ? 'general' : 'remote',
      }, billAuth);
      await get_statement_info();
    } catch (failure: any) {
      if (activeUid.current !== uid || requestLogin(failure)) return;
      setShippingRegionError(failure?.response?.data?.message || '도서산간 배송비를 반영하지 못했습니다.');
    } finally { setShippingRegionBusy(false); }
  };

  const freeShippingReached = statement?.shipping_mode === 'threshold'
    && Number(statement.free_shipping_threshold) > 0
    && purchase - cancelRefund >= Number(statement.free_shipping_threshold);
  const remotePriceDiffers = Number(statement?.remote_delivery_price ?? 7000)
    !== Number(statement?.base_delivery_price ?? 4000);
  const remoteAreaControl = statement?.can_edit_address === true
    && statement.shipping_region !== 'jeju'
    && statement.shipping_mode !== 'free'
    && !freeShippingReached
    && remotePriceDiffers ? <RemoteAreaBox>
    <div><strong>도서산간 배송지인가요?</strong><span>해당하면 도서산간 배송비가 결제금액에 반영됩니다.</span></div>
    <button type="button" onClick={toggleRemoteShipping} disabled={shippingRegionBusy} aria-pressed={statement.shipping_region === 'remote'}>
      {shippingRegionBusy ? '반영 중…' : statement.shipping_region === 'remote' ? '도서산간 적용됨' : '도서산간 적용'}
    </button>
    {shippingRegionError && <p role="alert">{shippingRegionError}</p>}
  </RemoteAreaBox> : null;

  useEffect(() => {
    let stopped = false;
    let timer: ReturnType<typeof setTimeout>;
    setStatement(null);
    setList([]);
    setReceiptError('');
    setIsEditingRequestNote(false);
    setRequestNoteError('');
    setRequestNoteSaved(false);
    setIsPaid(false);
    setIsViewingDetail(new URLSearchParams(location.search).get('view') === 'purchases');
    setAgreementAttention(false);
    setAgree1(false); setAgree2(false); setAgree3(false);
    const refresh = async (attempt = 0) => {
      const data = await get_statement_info();
      if (stopped) return;
      if (attempt === 0 && paymentReturn === "return" && data?.is_order_owner === true && !isPgPaid(data)) await reviewPayment();
      if (stopped) return;
      if (paymentReturn === "return" && data && !isPgPaid(data) && attempt < 5) {
        timer = setTimeout(() => refresh(attempt + 1), 2000);
      }
    };
    refresh();
    const onFocus = () => { if (document.visibilityState !== 'hidden' && !paying.current) void get_statement_info(); };
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onFocus);
    const bankTimer = window.setInterval(onFocus, 60000);
    return () => { stopped = true; statementRequest.current += 1; clearTimeout(timer); window.clearInterval(bankTimer); window.removeEventListener('focus', onFocus); document.removeEventListener('visibilitychange', onFocus); };
  }, [uid, location.search]);

  // 전체 동의 핸들러
  const handleAgreeAll = () => {
    const nextVal = !(agree1 && agree2 && agree3);
    setAgree1(nextVal);
    setAgree2(nextVal);
    setAgree3(nextVal);
  };

  const allAgreed = agree1 && agree2 && agree3;

  const canEditRequestNote = statement?.is_order_owner === true && statement?.can_edit_request_memo === true;
  const handleSaveRequestNote = async () => {
    if (!uid || !canEditRequestNote || requestNoteSaving.current) return;
    requestNoteSaving.current = true;
    setSavingRequestNote(true);
    setRequestNoteError('');
    setRequestNoteSaved(false);
    try {
      const { data } = await api.patch(url.Communication_url.order_request_memo, {
        seq: Number(uid), request_memo: draftRequestNote.trim(),
      }, billAuth);
      if (activeUid.current !== uid) return;
      if (typeof data?.request_memo !== 'string') throw new Error('요청사항 저장에 실패했습니다.');
      statementRequest.current += 1;
      setRequestNote(data.request_memo);
      setStatement((current: any) => current ? { ...current, request_memo: data.request_memo } : current);
      setIsEditingRequestNote(false);
      setRequestNoteSaved(true);
    } catch (error: any) {
      if (activeUid.current !== uid || requestLogin(error)) return;
      const message = error?.response?.data?.message;
      setRequestNoteError(typeof message === 'string' ? message : '요청사항을 저장하지 못했습니다. 다시 시도해주세요.');
    } finally {
      requestNoteSaving.current = false;
      setSavingRequestNote(false);
    }
  };

  // 배송지 수정 진입
  const enterEditMode = () => {
    if (statement?.can_edit_address !== true) return;
    setIsEditingRequestNote(false);
    setRequestNoteSaved(false);
    setTempRecipient(recipient);
    setTempPhone(phone);
    setTempPostCode(postCode);
    setTempFirAddr(firAddr);
    setTempSecAddr(secAddr);
    setTempRequestNote(requestNote === "-" ? "" : requestNote);
    setIsEditingAddress(true);
  };

  // 배송지 수정 완료
  const handleSaveAddress = async () => {
    if (saving.current || !statement || statement.can_edit_address !== true) return;
    if (!tempRecipient.trim() || !tempPhone.trim() || !tempPostCode.trim() || !tempFirAddr.trim()) {
      alert("받는 분, 연락처, 우편번호와 주소를 입력해주세요.");
      return;
    }
    saving.current = true; setSavingAddress(true);
    try {
      const { data } = await api.patch(url.Communication_url.order_address_update, {
        seq: Number(uid), addr_recipient: tempRecipient.trim(), addr_phone: tempPhone.trim(),
        addr_num: tempPostCode.trim(), addr_basic: tempFirAddr.trim(),
        addr_detail: tempSecAddr.trim(), request_memo: tempRequestNote.trim(),
      }, { ...billAuth, headers: { "Content-Type": "application/json" } });
      if (data !== "성공") throw new Error("배송지 저장에 실패했습니다.");
      await get_statement_info();
      setIsEditingAddress(false);
    } catch (error: any) {
      if (activeUid.current !== uid || requestLogin(error)) return;
      alert(error?.response?.data?.message || "배송지를 저장하지 못했습니다. 로그인 상태와 입력 내용을 확인해주세요.");
    } finally {
      saving.current = false; setSavingAddress(false);
    }
  };

  // 주소 검색 API
  const openSearchAddr = () => {
    SearchAddrApi({
      setFirAddr: setTempFirAddr,
      setPostCode: setTempPostCode,
      setDetail: setTempSecAddr,
    });
  };

  const handlePayClick = () => {
    if (!statement || paymentBusy || isPgPaid(statement) || !list.some(item => item.order_status === "결제대기")) return;
    if (!allAgreed) {
      setAgreementAttention(true);
      agreeAllRef.current?.focus({ preventScroll: true });
      agreementRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    setIsConfirmPayOpen(true);
  };

  const confirmPayment = async () => {
    if (combinedPreview) { setIsConfirmPayOpen(false); return; }
    if (paying.current || !allAgreed) return;
    paying.current = true; setPaymentBusy(true);
    setIsConfirmPayOpen(false);
    try {
      const latest = await get_statement_info();
      if (!latest) return; // The lookup already presents login or a retry state.
      if (isPgPaid(latest)) { if (isStatementPaid(latest)) setIsSuccessPayOpen(true); return; }
      if (!latest.addr_recipient || !latest.addr_phone || !latest.addr_basic) {
        throw new Error("배송지를 입력한 후 결제해주세요.");
      }
      const method = paymentMethod;
      const { data } = await api.post(method === 'HF' ? url.Communication_url.create_hf_payment : url.Communication_url.create_card_payment,
        paymentRequest(latest, method), { ...billAuth, headers: { "Content-Type": "application/json" } });
      if (activeUid.current !== uid) return;
      await (method === 'HF' ? launchHFPayment(data) : launchCardPayment(data));
    } catch (error: any) {
      if (activeUid.current !== uid || requestLogin(error)) return;
      setPaymentError(error?.response?.data?.message || error?.message || "결제를 시작하지 못했습니다.");
      setIsFailPayOpen(true);
    } finally {
      paying.current = false; setPaymentBusy(false);
    }
  };

  const handleSuccessConfirm = () => {
    setIsSuccessPayOpen(false);
    get_statement_info();
  };

  // 송장번호 복사 및 팝업 활성화
  const handleCopyTracking = (carrier: string, trackNum: string) => {
    navigator.clipboard.writeText(trackNum).then(() => {
      setSelectedTracking({ carrier, trackNum });
      setIsCopyModalOpen(true);
    }).catch(err => {
      console.error("클립보드 복사 실패", err);
    });
  };

  // 택배사 조회 페이지 이동
  const handleGoToCarrier = () => {
    if (selectedTracking) {
      const entry = carrierTrackingLink(selectedTracking.carrier, selectedTracking.trackNum);
      if (entry) {
        window.open(entry.url, "_blank", "noopener,noreferrer");
      } else {
        alert("해당 택배사 링크를 찾을 수 없습니다.");
      }
    }
    setIsCopyModalOpen(false);
  };

  // 취소된 상품도 같은 목록에 유지하고 금액은 서버의 쿠폰 배분을 따른다.
  const groupedList = list.reduce((acc: any[], current) => {
    const existing = acc.find(item => (current.product_seq !== undefined ? item.product_seq === current.product_seq : item.product_name === current.product_name)
      && item.payment_method === current.payment_method && item.items[0]?.order_status === current.order_status
      && item.items[0]?.cancellation_source === current.cancellation_source);
    const cancelled = ['주문취소', '환불처리', '사고처리'].includes(current.order_status);
    const quantity = cancelled ? 0 : Math.max(0, Number(current.order_cnt) - Number(current.cancel_cnt || 0));
    const price = cancelled ? 0 : Number(current.net_product_amount ?? Math.max(0, current.order_price - Number(current.cancel_price || 0)));
    if (existing) {
      existing.items.push(current);
      existing.total_qty += quantity;
      existing.total_discount += Number(current.coupon_discount_amount || 0);
      existing.total_price += price;
    } else {
      acc.push({ product_name: current.product_name, product_seq: current.product_seq, payment_method: current.payment_method,
        items: [current], total_qty: quantity, total_discount: Number(current.coupon_discount_amount || 0), total_price: price });
    }
    return acc;
  }, []);

  const cancellationRecords: any[] = Array.isArray(statement?.cancellations) ? statement.cancellations.filter((record: any) => record.restored !== true) : [];
  const remainingRecorded = cancellationRecords.map(record => Number(record.quantity || 0));
  const cancellationRows = [...cancellationRecords];
  list.forEach((item, index) => {
    const fullyCancelled = ['주문취소', '환불처리', '사고처리'].includes(item.order_status);
    let quantity = fullyCancelled ? Number(item.order_cnt) : Math.min(Number(item.order_cnt), Number(item.cancel_cnt || 0));
    if (quantity <= 0) return;
    let amount = fullyCancelled ? Number(item.order_price) : Number(item.cancel_price ?? quantity * Number(item.product_price ?? item.order_price / Math.max(1, item.order_cnt)));
    cancellationRecords.forEach((record, recordIndex) => {
      const sameDetail = item.seq !== undefined && record.detail_seq != null ? item.seq === Number(record.detail_seq)
        : (item.product_seq !== undefined && record.product_seq != null ? item.product_seq === Number(record.product_seq) : item.product_name === record.product_name)
          && (item.option_name || '') === (record.option_name || '')
          && (!item.cancellation_source || item.cancellation_source === record.source);
      if (!sameDetail || quantity <= 0) return;
      const covered = Math.min(quantity, remainingRecorded[recordIndex]);
      amount -= Number(record.amount || 0) * covered / Math.max(1, Number(record.quantity || 0));
      quantity -= covered; remainingRecorded[recordIndex] -= covered;
    });
    if (quantity > 0) cancellationRows.push({ seq: -(index + 1), detail_seq: item.seq, product_seq: item.product_seq, product_name: item.product_name,
      option_name: item.option_name, quantity, amount: Math.max(0, Math.round(amount)),
      source: item.cancellation_source, order_status: fullyCancelled ? item.order_status : '주문취소' });
  });

  const individualDeliveryPrice = useMemo(() => {
    if (list.length > 0 && list.every(item => item.individual_delivery === true || item.individual_delivery === 1)) return delivery_price;
    const fees = new Map<number | undefined, number>();
    for (const item of list) {
      if (!item.individual_delivery || ['주문취소', '환불처리', '사고처리'].includes(item.order_status)
        || Number(item.order_cnt) <= Number(item.cancel_cnt || 0) || fees.has(item.product_seq)) continue;
      fees.set(item.product_seq, Number(item.individual_delivery_price || 0));
    }
    return Math.min(delivery_price, [...fees.values()].reduce((sum, fee) => sum + fee, 0));
  }, [list, delivery_price]);

  const settlementAmountSummary = <section aria-label="정산 금액 요약">
    <PriceSummary>
      <SummaryRow>
        <div className="label">전체 금액</div>
        <div className="value">{(totalPayment + discountAmount - delivery_price).toLocaleString()}원</div>
      </SummaryRow>
      {discountAmount > 0 && <SummaryRow>
        <div className="label">할인 금액</div>
        <div className="value">-{discountAmount.toLocaleString()}원</div>
      </SummaryRow>}
      <SummaryRow>
        <div className="label">배송비</div>
        <div className="value">{(delivery_price - individualDeliveryPrice).toLocaleString()}원</div>
      </SummaryRow>
      <SummaryRow>
        <div className="label">개별 배송비</div>
        <div className="value">{individualDeliveryPrice.toLocaleString()}원</div>
      </SummaryRow>
    </PriceSummary>
    <FinalPayRow>
      <div className="label">최종 금액</div>
      <div className="price">{totalPayment.toLocaleString()}원</div>
    </FinalPayRow>
  </section>;

  const unmatchedCancellations = cancellationRows.filter(record => !list.some(item => matchesPurchase(item, record)));
  const cancellationHistory = unmatchedCancellations.length > 0 ? <CancellationHistory aria-label="취소 이력">
    <h2>취소 이력</h2>
    {groupCancellationHistory(unmatchedCancellations).map((item: any) => <section key={item.seq}>
      <div className="cancellation-heading"><strong className="cancel-status"><BuyerFeatureIcon name="cancel" size={16} />{item.order_status === '사고처리' ? '관리자 확인 중' : item.source === 'system' ? '자동 취소' : item.source === 'admin' ? item.pgCompleted ? '관리자 결제 취소' : '관리자 취소' : item.source === 'customer' ? '고객 취소' : item.order_status || '주문취소'}</strong>
        {(item.source !== 'customer' || item.reasons.length > 0) && <span>취소 사유: {item.reasons.join(' · ') || '미기록'}</span>}</div>
      {item.bankPending && <p className="refund-status">환불 대기</p>}{item.bankCompleted && <p className="refund-status">환불 완료</p>}
      <p>{item.product_name}{item.option_names.length ? ` · ${item.option_names.join(' / ')}` : ''} · {item.quantity}개</p>
      <span className="cancel-amount">{Number(item.amount).toLocaleString()}원</span>
    </section>)}
  </CancellationHistory> : null;

  const pgPaymentDeadline = paymentSummary && paymentSummary.pg_due_amount > 0 && paymentSummary.pg_deadline
    ? <><BankDeadline aria-label="PG 결제 기한" $attention={!!paymentSummary.pg_attention}>
      {paymentSummary.pg_attention && <span className="dot" aria-hidden="true" />}
      <strong>{paymentSummary.pg_overdue ? 'PG 결제 기한 경과' : paymentSummary.pg_attention ? 'PG 결제 기한 임박' : 'PG 결제 기한'}</strong>
      <span>{paymentDate(paymentSummary.pg_deadline)}</span>
    </BankDeadline>{paymentSummary.pg_auto_cancel && <p>{paymentSummary.pg_overdue
      ? '결제 기한이 지나 자동 취소 처리 중입니다. 주문 상태를 새로고침해주세요.'
      : '결제 기한까지 결제가 완료되지 않으면 주문이 자동 취소됩니다.'}</p>}</> : null;

  const refundAccountCard = statement?.is_order_owner === true && statement.has_active_refund_request === true
    && paymentSummary && paymentSummary.payment_mode !== 'pg'
    ? <BillRefundAccount refreshKey={refundAccountRefresh} onEdit={() => { setProfileEditSection("refund"); setProfileEditOpen(true); }} /> : null;
  const bankPaymentInfo = paymentSummary && paymentSummary.bank_amount > 0 ? <BankPaymentSection id="bank-info" aria-label="무통장 입금 정보">
    <h2>{paymentModeLabel(paymentSummary.payment_mode)}</h2>
    {paymentSummary.pg_amount > 0 && <SummaryRow><span>PG 결제 {paymentSummary.pg_paid ? '완료' : '대기'}</span><strong>{paymentSummary.pg_amount.toLocaleString()}원</strong></SummaryRow>}
    <SummaryRow><BankStatus $state={paymentSummary.bank_paid ? 'paid' : paymentSummary.deposit_overdue ? 'overdue' : 'pending'}>무통장 {paymentSummary.bank_paid ? '입금 확인' : '입금 대기'}</BankStatus><strong>{paymentSummary.bank_amount.toLocaleString()}원</strong></SummaryRow>
    {paymentSummary.bank_paid ? <p role="status">입금이 확인되었습니다.{paymentSummary.bank_paid_at && ` (${paymentDate(paymentSummary.bank_paid_at)})`}</p> : <>
      <BankDeadline $attention={paymentSummary.deposit_attention}>
        {paymentSummary.deposit_attention && <span className="dot" aria-hidden="true" />}
        <strong>{paymentSummary.deposit_overdue ? '입금 기한 경과' : paymentSummary.deposit_attention ? '입금 기한 임박' : '입금 기한'}</strong>
        <span>{paymentDate(paymentSummary.deposit_deadline)}</span>
      </BankDeadline>
      {paymentSummary.bank_auto_cancel ? <p>{paymentSummary.deposit_overdue
        ? '입금 기한이 지나 자동 취소 처리 중입니다. 입금하지 말고 주문 상태를 새로고침해주세요.'
        : '입금 기한까지 입금이 확인되지 않으면 주문이 자동 취소됩니다.'}</p>
        : paymentSummary.deposit_overdue && <p>입금 기한이 지나도 입금할 수 있습니다.</p>}
      {paymentSummary.bank_auto_cancel && paymentSummary.deposit_overdue ? null : paymentSummary.pg_due_amount > 0 ? <p>PG 결제를 완료하면 무통장 입금 계좌를 안내해드립니다.</p> : paymentSummary.bank_account ? <>
        <BankAccount><div><dt>은행</dt><dd>{paymentSummary.bank_account.bank_name}</dd></div><div><dt>계좌번호</dt><dd>{paymentSummary.bank_account.bank_num}</dd></div><div><dt>예금주</dt><dd>{paymentSummary.bank_account.depositor}</dd></div><div><dt>입금할 금액</dt><dd>{paymentSummary.bank_due_amount.toLocaleString()}원</dd></div></BankAccount>
        <p>셀러가 입금 내역을 확인하면 입금 완료로 변경됩니다.</p>
      </> : <p role="alert">입금 계좌 정보를 확인할 수 없습니다. 셀러에게 문의해주세요.</p>}
    </>}
    {refundAccountCard}
    {!paymentSummary.bank_paid && <BankStatusRefresh type="button" onClick={() => void get_statement_info()}>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><path d="M20 7v5h-5"/><path d="M19.2 12a7.5 7.5 0 1 0-1.8 5"/></svg>
      입금 확인 상태 새로고침
    </BankStatusRefresh>}
  </BankPaymentSection> : null;

  const requestNoteRow = <InfoRow>
    <div className="label">요청사항</div>
    <RequestNoteContent className="value">
      {isEditingRequestNote && canEditRequestNote ? <>
        <TextareaRequest
          aria-label="요청사항"
          value={draftRequestNote}
          onChange={event => setDraftRequestNote(event.target.value)}
          placeholder="요청사항을 입력해주세요."
          maxLength={500}
          disabled={savingRequestNote}
          autoFocus
        />
        <div className="request-note-actions">
          <RequestNoteButton type="button" disabled={savingRequestNote} onClick={() => { setIsEditingRequestNote(false); setRequestNoteError(''); }}>취소</RequestNoteButton>
          <RequestNoteButton type="button" disabled={savingRequestNote} onClick={handleSaveRequestNote}>{savingRequestNote ? '저장 중…' : '저장'}</RequestNoteButton>
        </div>
      </> : <div className="request-note-display">
        <span>{requestNote}</span>
        {canEditRequestNote && <RequestNoteButton type="button" aria-label="요청사항 수정" onClick={() => {
          setDraftRequestNote(requestNote); setRequestNoteError(''); setRequestNoteSaved(false); setIsEditingRequestNote(true);
        }}>수정</RequestNoteButton>}
      </div>}
      {requestNoteError && <p role="alert">{requestNoteError}</p>}
      {requestNoteSaved && <p role="status">요청사항이 저장되었습니다.</p>}
    </RequestNoteContent>
  </InfoRow>;

  if (loginRequired) return (
    <Layout_user background="white"><StatePage label="정산서" backHref="/orders" icon="account" kind="locked"
      title="정산서를 확인하려면 로그인해주세요"
      description="주문한 구매자의 카카오 계정으로 로그인해주세요. 로그인 후 이 정산서로 돌아옵니다."
      action={{ label: "카카오 로그인", href: loginUrl.href }} /></Layout_user>
  );

  if (!statement) return (
    <Layout_user background="white"><StatePage label="정산서" backHref="/orders" icon="document" kind={loadError ? "error" : "loading"}
      title={loadError || "정산서를 불러오는 중입니다."}
      description={loadError ? "주문 내역에서 해당 주문을 다시 확인할 수 있어요." : "주문 상품과 결제 정보를 확인하고 있어요."}
      action={loadError ? { label: "다시 시도", onClick: get_statement_info } : undefined}
      secondaryAction={loadError ? { label: "주문 내역", href: "/orders" } : undefined} /></Layout_user>
  );

  return (
    <Layout_user isScroll="none" background="white"><BillViewport>
      {/* Keep navigation outside the scrolling layer in in-app WebViews. */}
      {isEditingAddress ? (
        <HeaderBar>
          <BackButton type="button" aria-label="뒤로가기" onClick={() => setIsEditingAddress(false)}>
            <Icon src={require("../../../Image/ic_left_black.png")} alt="" />
          </BackButton>
          <HeaderTitle>배송 정보 수정</HeaderTitle>
        </HeaderBar>
      ) : isViewingDetail ? (
        <HeaderBar>
          <BackButton type="button" aria-label="정산서로 돌아가기" onClick={() => setIsViewingDetail(false)}>
            <Icon src={require("../../../Image/ic_left_black.png")} alt="" />
          </BackButton>
          <HeaderTitle>구매 목록</HeaderTitle>
        </HeaderBar>
      ) : (
        <PurchaseHeaderBar>
          <BackButton type="button" aria-label="뒤로가기" onClick={() => navigate(-1)}>
            <Icon src={require("../../../Image/ic_left_black.png")} alt="" />
          </BackButton>
          <HeaderTitle>정산서</HeaderTitle>
          {statement.is_order_owner === true && <ProfileEditButton as="button" type="button" onClick={() => { setProfileEditSection("profile"); setProfileEditOpen(true); }}>내 정보 수정</ProfileEditButton>}
        </PurchaseHeaderBar>
      )}
      <BillScroll aria-label="정산서 본문">
      {combinedPreview && <p role="status" style={{ padding: '12px 20px', margin: 0, color: 'var(--user-accent)' }}>복합 결제 화면 미리보기 · 실제 주문·결제는 변경되지 않습니다.</p>}
      <CancelTicketLetter liveSeq={Number(statement.live_seq)} enabled={statement.is_order_owner === true} />
      <div id="bill-top" ref={billTopRef} />
      <MyInfoModal initialSection={profileEditSection} visible={profileEditOpen} onClose={() => setProfileEditOpen(false)} onSaved={() => setRefundAccountRefresh(key => key + 1)} />
      {isEditingAddress ? (
        // ==========================================
        // 1. 배송 정보 수정 화면 뷰
        // ==========================================
        <Content>
          <EditInputWrapper>
            <EditField>
              <label>받는분</label>
              <InputText
                type="text"
                value={tempRecipient}
                onChange={(e) => setTempRecipient(e.target.value)}
              />
            </EditField>
            <EditField>
              <label>연락처</label>
              <InputText
                type="text"
                value={tempPhone}
                onChange={(e) => setTempPhone(e.target.value)}
              />
            </EditField>
            <EditField>
              <label>주소</label>
              <SearchRow>
                <InputText
                  type="text"
                  value={tempPostCode}
                  disabled
                  readOnly
                  style={{ width: "calc(100% - 88px)" }}
                />
                <SearchButton onClick={openSearchAddr}>검색</SearchButton>
              </SearchRow>
              <InputText
                type="text"
                value={tempFirAddr}
                disabled
                readOnly
                style={{ marginBottom: 8 }}
              />
              <InputText
                type="text"
                value={tempSecAddr}
                onChange={(e) => setTempSecAddr(e.target.value)}
                placeholder="상세주소를 입력해 주세요"
              />
            </EditField>
            <EditField>
              <label>배송시 요청사항</label>
              <TextareaRequest
                value={tempRequestNote}
                onChange={(e) => setTempRequestNote(e.target.value)}
                placeholder="요청사항을 입력해주세요."
              />
            </EditField>
          </EditInputWrapper>
          <FooterSubmitButton disabled={savingAddress} onClick={handleSaveAddress}>
            수정완료
          </FooterSubmitButton>
        </Content>
      ) : isViewingDetail ? (
        <Content>
          <section aria-label="구매 목록">
            {groupedList.length > 0 && <PurchaseCard>
            {groupedList.map((group: any, idx: number) => {
              const claimInfo = purchaseClaimInfo(group.items, statement?.claims || [], cancellationRows);
              return <ProductGroup as="article" aria-label={group.product_name} key={idx}>
                <GroupHeader>
                  <ProductName>{group.product_name}{group.payment_method && <small style={{ display: "block", marginTop: 4, fontSize: 12, color: "var(--user-text-muted)" }}>{group.payment_method === "bank" ? "무통장 입금" : "PG 결제"}</small>}</ProductName>
                  <div style={{ maxWidth: "48%" }}><BillDeliveryStatuses statuses={claimInfo.statuses} label="상품 상태" /></div>
                </GroupHeader>
                {group.items.map((item: any, optionIdx: number) => {
                  const optText = item.option_name?.replace("&", " / ");
                  if (!optText || optText.trim() === "") return null;
                  return (
                    <OptionRow key={optionIdx}>
                      · {optText}
                    </OptionRow>
                  );
                })}
                {group.total_discount > 0 && <ProductCoupon aria-label={`${group.product_name} 쿠폰 사용 내역`}><span>할인 쿠폰</span><strong>-{group.total_discount.toLocaleString()}원</strong></ProductCoupon>}
                {claimInfo.records.length > 0 && <PurchaseClaimDetails>
                  {claimInfo.records.map(record => <div key={record.key}>
                    <span>{record.label} · {record.quantity}개{record.amount !== null && ` · ${record.amount.toLocaleString()}원`}</span>
                    {record.reason && <p>사유: {record.reason}</p>}
                  </div>)}
                </PurchaseClaimDetails>}
                <ProductFooter>
                  {(!claimInfo.hasRefund || group.total_qty > 0) && <div className="amount-row">
                    <div className="qty">{claimInfo.records.length ? "남은 수량" : "총 수량"}: {group.total_qty}개</div>
                    <div className="price">{group.total_price.toLocaleString()}원</div>
                  </div>}
                  {claimInfo.hasRefund && <div className="amount-row" aria-label="상품 환불 금액">
                    <div className="qty">환불 완료 금액</div>
                    <div className="price">{claimInfo.refundAmount.toLocaleString()}원</div>
                  </div>}
                </ProductFooter>
              </ProductGroup>;
            })}
          </PurchaseCard>}

          {groupedList.length === 0 && <EmptyPurchase><BuyerFeatureIcon name="purchase" size={30} /><span>구매 내역이 없습니다.</span></EmptyPurchase>}
          {sellerGiftSection}
          {cancellationHistory}
          </section>
        </Content>
      ) : isPaid || (paymentSummary && paymentSummary.bank_amount > 0 && isPgPaid(statement)) ? (
        // ==========================================
        // 3. 결제 후 구매 정보(정산서 메인) 뷰
        // ==========================================
        <Content>

          {pgPaymentDeadline}
          {bankPaymentInfo}
          {!bankPaymentInfo && refundAccountCard}

          {/* 배송 정보 섹션 */}
          <SectionHeader id="shipping" style={{ marginTop: 8 }}>
            <SectionTitle>배송 정보</SectionTitle>
          </SectionHeader>
          <InfoCard>
            <InfoRow>
              <div className="label">받는분</div>
              <div className="value">
                {recipient} / {phone}
              </div>
            </InfoRow>
            <InfoRow>
              <div className="label">배송지</div>
              <div className="value">
                ({postCode}){firAddr}, {secAddr}
              </div>
            </InfoRow>
            {requestNoteRow}
            <InfoRow>
              <div className="label">배송상태</div>
              <div className="value">
                <BillDeliveryStatuses statuses={latestDeliveryStatus(list)} />
              </div>
            </InfoRow>
            <InfoRow style={{ alignItems: "flex-start" }}>
              <div className="label">송장번호</div>
              <div className="value" style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                {trackingList.map((track, idx) => (
                  <TrackingRow key={idx}>
                    <span className="carrier">{track.carrier}</span>
                    <span className="num">{track.trackNum}</span>
                    <CopyBtnIcon
                      src={require("../../../Image/ic_copy.png")}
                      onClick={() => handleCopyTracking(track.carrier, track.trackNum)}
                    />
                    {carrierTrackingLink(track.carrier, track.trackNum) && <TrackingExternal
                      href={carrierTrackingLink(track.carrier, track.trackNum)!.url} target="_blank" rel="noopener noreferrer"
                      onClick={() => { if (carrierTrackingLink(track.carrier, track.trackNum)?.needsInvoicePaste) void navigator.clipboard?.writeText(track.trackNum); }}>
                      배송 상세
                    </TrackingExternal>}
                  </TrackingRow>
                ))}
              </div>
            </InfoRow>
          </InfoCard>
          {productDeliverySection}
          <div hidden>{sellerGiftSection}</div>

          <PurchaseListButton as="button" type="button" onClick={() => { setIsViewingDetail(true); }}>구매 목록 보기 <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="m9 5 7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></PurchaseListButton>

          {/* 결제 정보 섹션 */}
          <SectionHeader>
            <SectionTitle>결제 정보</SectionTitle>
          </SectionHeader>
          <PriceSummary>
            <SummaryRow>
              <div className="label">결제 수단</div>
              <div className="value">{paymentSummary ? paymentModeLabel(paymentSummary.payment_mode) : statement.pay_method || "확인 중"}</div>
            </SummaryRow>
          </PriceSummary>
          {settlementAmountSummary}
          <ExtraChargeBox>{shippingPolicyText}</ExtraChargeBox>
          {remoteAreaControl}

          {/* 주문 상세 내역 보러가기 버튼 */}
          {(!paymentSummary || (paymentSummary.pg_paid && paymentSummary.pg_amount > 0)) && <DetailLinkButton as="button" type="button" onClick={openReceipt} disabled={receiptBusy}>
            {receiptBusy ? '영수증 조회 중…' : '결제 영수증 조회'} <span className="arrow">&gt;</span>
          </DetailLinkButton>}
          {statement.pay_method === '내통장결제' && <p>결제사에서 발급된 현금영수증을 조회합니다.</p>}
          {paymentSummary?.bank_paid && <CashReceiptStatus aria-label="무통장 현금영수증 발행 상태" $issued={!!statement.bank_cash_receipt?.issued}>
            <span className="receipt-icon"><BuyerFeatureIcon name="receipt" /></span>
            <div><div className="receipt-heading"><span>무통장 현금영수증:</span> <strong>{statement.bank_cash_receipt?.issued ? '발행' : '미발행'}</strong></div>
            {statement.bank_cash_receipt?.issued && statement.bank_cash_receipt?.receipt_number && <span className="receipt-number"> · 발행 번호 {statement.bank_cash_receipt.receipt_number}</span>}</div>
          </CashReceiptStatus>}
          {receiptError && <p role="alert">{receiptError}</p>}
          <DetailLinkButton as="button" type="button" onClick={() => navigate('/orders')}>주문 내역으로</DetailLinkButton>
          {sellerInquiry}
        </Content>
      ) : (
        // ==========================================
        // 4. 결제 전 구매 정보(정산서 메인) 뷰
        // ==========================================
        <Content $checkout={statement.is_order_owner !== false || combinedPreview}>

          {/* 배송 정보 섹션 */}
          <SectionHeader id="shipping" style={{ marginTop: 8 }}>
            <SectionTitle>배송 정보</SectionTitle>
            {statement.can_edit_address === true && <EditButton onClick={enterEditMode}>정보수정</EditButton>}
          </SectionHeader>
          {statement.address_edit_locked_reason && <p role="status">{statement.address_edit_locked_reason}</p>}
          <InfoCard>
            <InfoRow>
              <div className="label">받는분</div>
              <div className="value">
                {recipient} / {phone}
              </div>
            </InfoRow>
            <InfoRow>
              <div className="label">배송지</div>
              <div className="value">
                ({postCode}){firAddr}, {secAddr}
              </div>
            </InfoRow>
            {requestNoteRow}
          </InfoCard>
          {productDeliverySection}
          <div hidden>{sellerGiftSection}</div>

          <PurchaseListButton as="button" type="button" onClick={() => { setIsViewingDetail(true); }}>구매 목록 보기 <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="m9 5 7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></PurchaseListButton>

          {/* 결제 금액 섹션 */}
          <SectionHeader>
            <SectionTitle>결제 금액</SectionTitle>
          </SectionHeader>
          {settlementAmountSummary}
          <ExtraChargeBox>{shippingPolicyText}</ExtraChargeBox>
          {remoteAreaControl}

          {pgPaymentDeadline}
          {bankPaymentInfo}
          {!bankPaymentInfo && refundAccountCard}
          {paymentSummary && paymentSummary.bank_amount > 0 && <FinalPayRow><div className="label">지금 결제할 PG 금액</div><div className="price">{paymentSummary.pg_due_amount.toLocaleString()}원</div></FinalPayRow>}

          {paymentReturn === "cancelled" && <p role="status">결제를 취소했습니다.</p>}
          {paymentReturn === "return" && !isPgPaid(statement) && (statement?.payment_result === "failed"
            ? <p role="status">결제에 실패했습니다. 결제 수단을 확인하고 다시 시도해주세요.</p>
            : <PaymentReturnNotice role="status">
                <p><strong>결제 승인 내역을 확인 중입니다.</strong>{' '}완료 여부가 반영되지 않으면 <span>결제 상태 새로고침</span>을 눌러주세요.</p>
                <PaymentStatusRefresh type="button" onClick={reviewPayment} disabled={paymentReviewBusy}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false"><path d="M20 7v5h-5"/><path d="M19.2 12a7.5 7.5 0 1 0-1.8 5"/></svg>
                  {paymentReviewBusy ? '결제 확인 중…' : '결제 상태 새로고침'}
                </PaymentStatusRefresh>
                {paymentReviewError && <p role="alert">{paymentReviewError}</p>}
              </PaymentReturnNotice>)}
          {statement?.payment_result === 'review' && <p role="alert">이전 결제 결과를 확인 중입니다. 중복 결제를 방지하기 위해 결제가 제한됩니다. 고객센터에 문의해주세요.</p>}
          {statement.is_order_owner === false && !combinedPreview ? <>
            <p role="status">{BUYER_PAYMENT_LOGIN_MESSAGE}</p>
            <BankRefresh as="a" href={loginUrl.href}>구매자 카카오 계정으로 로그인</BankRefresh>
          </> : !giftOnlyPurchase && <>
          <PaymentMethods disabled={paymentBusy}>
            <legend>결제 수단</legend>
            <label><input type="radio" name="payment-method" value="card" checked={paymentMethod === 'card'} onChange={() => setPaymentMethod('card')} />신용카드</label>
            <label><input type="radio" name="payment-method" value="HF" checked={paymentMethod === 'HF'} onChange={() => setPaymentMethod('HF')} />내통장결제</label>
          </PaymentMethods>
          {/* 이용약관 동의 섹션 */}
          <AgreeSection ref={agreementRef} $attention={agreementAttention && !allAgreed}>
            <AgreeItem>
              <label className="left bold">
                <input ref={agreeAllRef} type="checkbox" checked={allAgreed} onChange={handleAgreeAll} />
                <CustomCheckbox aria-hidden="true" $checked={allAgreed} />
                전체 동의
              </label>
            </AgreeItem>
            <AgreeItem>
              <label className="left">
                <input type="checkbox" checked={agree1} onChange={event => setAgree1(event.target.checked)} />
                <CustomCheckbox aria-hidden="true" $checked={agree1} />
                [필수] 구매조건 동의
              </label>
              <a className="detail" href={statement.store_seq === 1 ? '/rule-seller/1?storeSeq=1' : '/rule/1'} target="_blank" rel="noopener noreferrer" aria-label="구매조건 관련 이용약관 보기">이용약관 보기 &gt;</a>
            </AgreeItem>
            <AgreeItem>
              <label className="left">
                <input type="checkbox" checked={agree2} onChange={event => setAgree2(event.target.checked)} />
                <CustomCheckbox aria-hidden="true" $checked={agree2} />
                [필수] 개인정보 제3자 제공 동의
              </label>
              <a className="detail" href={statement.store_seq === 1 ? '/rule-seller/2?storeSeq=1' : '/rule/2'} target="_blank" rel="noopener noreferrer" aria-label="개인정보 처리방침 보기">처리방침 보기 &gt;</a>
            </AgreeItem>
            <AgreeItem>
              <label className="left">
                <input type="checkbox" checked={agree3} onChange={event => setAgree3(event.target.checked)} />
                <CustomCheckbox aria-hidden="true" $checked={agree3} />
                [필수] 전자금융거래 약관 동의
              </label>
              <a className="detail" href="https://www.hectofinancial.co.kr/provision" target="_blank" rel="noopener noreferrer" aria-label="헥토파이낸셜 전자금융거래 이용약관 보기">자세히 &gt;</a>
            </AgreeItem>
          </AgreeSection>

          </>}
          {sellerInquiry}
        </Content>
      )}

      </BillScroll>

      {!giftOnlyPurchase && !isEditingAddress && !isViewingDetail && !isPaid && !isPgPaid(statement) && (statement.is_order_owner !== false || combinedPreview) && (
        <PaymentActionBar>
          <FooterPayButton type="button" disabled={paymentBusy || statement?.payment_result === 'review' || !list.some(item => item.order_status === "결제대기")}
            $disabled={paymentBusy || statement?.payment_result === 'review'} onClick={handlePayClick}>
            결제하기
          </FooterPayButton>
        </PaymentActionBar>
      )}

      {/* ==========================================
          4. 팝업 모달 레이어 정의
          ========================================== */}

      {/* 결제 확인 팝업 */}
      {isConfirmPayOpen && (
        <AlertOverlay onClick={() => setIsConfirmPayOpen(false)}>
          <AlertBox onClick={(e) => e.stopPropagation()}>
            <AlertTitle>결제</AlertTitle>
            <AlertText>{combinedPreview ? "결제 화면 미리보기입니다. 실제 결제는 진행되지 않습니다." : "결제를 진행할까요?"}</AlertText>
            <AlertButtonRow>
              <AlertCancelBtn onClick={() => setIsConfirmPayOpen(false)}>
                취소
              </AlertCancelBtn>
              <AlertConfirmBtn onClick={confirmPayment}>
                확인
              </AlertConfirmBtn>
            </AlertButtonRow>
          </AlertBox>
        </AlertOverlay>
      )}

      {/* 결제 완료 성공 팝업 */}
      {isSuccessPayOpen && (
        <AlertOverlay onClick={handleSuccessConfirm}>
          <AlertBox onClick={(e) => e.stopPropagation()}>
            <AlertTitle>결제 완료</AlertTitle>
            <AlertText>결제가 완료되었어요.</AlertText>
            <AlertButtonRow>
              <AlertConfirmBtn onClick={handleSuccessConfirm}>
                확인
              </AlertConfirmBtn>
            </AlertButtonRow>
          </AlertBox>
        </AlertOverlay>
      )}

      {/* 결제 실패 에러 팝업 */}
      {isFailPayOpen && (
        <AlertOverlay onClick={() => setIsFailPayOpen(false)}>
          <AlertBox onClick={(e) => e.stopPropagation()}>
            <AlertTitle>결제 실패</AlertTitle>
            <AlertText>{paymentError}</AlertText>
            <AlertButtonRow>
              <AlertConfirmBtn onClick={() => setIsFailPayOpen(false)}>
                확인
              </AlertConfirmBtn>
            </AlertButtonRow>
          </AlertBox>
        </AlertOverlay>
      )}

      {/* 송장번호 복사 완료 팝업 (택배사 링크 이동 유도) */}
      {isCopyModalOpen && (
        <AlertOverlay onClick={() => setIsCopyModalOpen(false)}>
          <AlertBox onClick={(e) => e.stopPropagation()}>
            <AlertTitle>복사 완료</AlertTitle>
            <AlertText>
              {selectedTracking && carrierTrackingLink(selectedTracking.carrier, selectedTracking.trackNum)?.needsInvoicePaste
                ? "송장번호는 복사됐어요. 택배사 조회 페이지로 이동해 붙여넣어 주세요."
                : "택배사로 이동할까요?"}
            </AlertText>
            <AlertButtonRow>
              <AlertCancelBtn onClick={() => setIsCopyModalOpen(false)}>
                취소
              </AlertCancelBtn>
              <AlertConfirmBtn onClick={handleGoToCarrier}>
                이동하기
              </AlertConfirmBtn>
            </AlertButtonRow>
          </AlertBox>
        </AlertOverlay>
      )}
    </BillViewport></Layout_user>
  );
};

export default User_Bill;

// 스타일드 컴포넌트들 정의
const BankStatus = styled.span<{ $state: 'pending' | 'paid' | 'overdue' }>`
  display: inline-flex; align-items: center; gap: 6px; padding: 5px 10px; border-radius: 6px;
  font-size: 13px; line-height: 1.5; font-weight: 600;
  color: ${({ $state }) => $state === 'paid' ? 'var(--user-success)' : $state === 'overdue' ? 'var(--user-error)' : 'var(--user-warning)'};
  background: ${({ $state }) => $state === 'paid' ? 'var(--user-success-soft)' : $state === 'overdue' ? 'var(--user-error-soft)' : 'var(--user-warning-soft)'};
  &::before { content: ''; width: 6px; height: 6px; flex-shrink: 0; border-radius: 50%; background: currentColor; }
`;

const BankPaymentSection = styled.section`
  margin:24px 0;padding:20px 0;border-top:1px solid var(--user-border);border-bottom:1px solid var(--user-border);
  &:first-child { margin-top:0; padding-top:4px; border-top:0; }
  h2{margin:0 0 18px;font-size:18px;}p{margin:14px 0 0;line-height:1.6;font-size:14px;color:var(--user-text-muted);}
`;
const BankDeadline = styled.div<{ $attention: boolean }>`
  display:flex;align-items:center;flex-wrap:wrap;gap:8px;margin-top:18px;font-size:14px;line-height:1.5;color:${props => props.$attention ? 'var(--user-error)' : 'var(--user-text-muted)'};
  .dot{width:8px;height:8px;border-radius:50%;background:#d92d20;}
`;
const BankAccount = styled.dl`
  margin:20px 0 0;padding:16px;background:var(--user-surface-raised);border-radius:8px;user-select:text;
  div{display:flex;justify-content:space-between;gap:16px;margin:10px 0;font-size:14px;line-height:1.5;}dt{color:var(--user-text-muted);flex-shrink:0;}dd{margin:0;text-align:right;overflow-wrap:anywhere;font-weight:600;}
`;
const BankRefresh = styled.button`
  margin-top:16px;min-height:44px;padding:10px 16px;border:1px solid var(--user-border);border-radius:8px;background:var(--user-surface);color:var(--user-text);font:inherit;font-size:14px;cursor:pointer;
  &:hover{background:var(--user-surface-raised);}&:focus-visible{outline:3px solid var(--user-accent);outline-offset:3px;}
`;

const BankStatusRefresh = styled(BankRefresh)`
  display: flex; align-items: center; justify-content: center; gap: 8px;
  width: 100%; min-height: 48px; box-sizing: border-box; margin-top: 20px;
  font-weight: 600; line-height: 1.5;
  svg { flex-shrink: 0; color: var(--user-text-muted); }
  &:hover { background: var(--user-surface-raised); border-color: var(--user-accent); }
  &:active { background: var(--user-accent-soft); }
  &:focus-visible { outline: 2px solid var(--user-accent); outline-offset: 3px; }
`;

const PaymentReturnNotice = styled.div`
  margin-top: 24px;
  padding: 16px;
  border: 1px solid var(--user-border);
  border-radius: 12px;
  background: var(--user-surface-raised);
  p { margin: 0; color: var(--user-text-muted); font-size: 14px; line-height: 1.65; word-break: keep-all; overflow-wrap: anywhere; }
  strong { display: block; margin-bottom: 6px; color: var(--user-text); font-weight: 600; }
  p span { color: var(--user-text); }
`;

const PaymentStatusRefresh = styled(BankStatusRefresh)`
  margin-top: 14px;
  border-color: var(--user-accent);
  background: var(--user-accent-soft);
  color: var(--user-accent);
  svg { color: currentColor; }
  &:hover { background: var(--user-surface); }
`;

const BillViewport = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: var(--browser-layout-height, 100dvh);
  overflow: hidden;
  background: var(--user-surface);
  color: var(--user-text);
  font-family: var(--font-Pretendard-Regular);
`;

const BillScroll = styled.main`
  flex: 1;
  min-height: 0;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior-y: contain;
  &::-webkit-scrollbar { display: none; }
`;

const Content = styled.div<{ $checkout?: boolean }>`
  padding: 16px;
  padding-bottom: ${props => props.$checkout ? 'calc(104px + env(safe-area-inset-bottom))' : '80px'};
  background-color: var(--user-surface);
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  [id] { scroll-margin-top: 16px; }
`;

const HeaderBar = styled(RowView)`
  position: relative;
  flex-shrink: 0;
  z-index: 20;
  width: 100%;
  max-width: 500px;
  min-height: 56px;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid var(--user-border);
  box-sizing: border-box;
  margin: 0 auto;
  padding: 0 16px;
  background: var(--user-surface);
`;

const PurchaseHeaderBar = styled(HeaderBar)`
  justify-content: center;
  padding-inline: 108px;
  text-align: center;
  word-break: keep-all;
`;

const BackButton = styled.button`
  position: absolute;
  left: 16px;
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border: 0;
  padding: 0;
  background: transparent;
  cursor: pointer;
  img { width: 24px; height: 24px; filter: var(--user-icon-filter); }
  &:focus-visible { outline: 2px solid #7955f0; outline-offset: 2px; }
`;

const HeaderTitle = styled.div`
  font-size: 18px;
  font-family: var(--font-Pretendard-Bold);
  color: var(--user-text);
`;

const SectionHeader = styled(RowView)`
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 24px;
  margin-bottom: 12px;
`;

const SectionTitle = styled.div`
  font-size: 16px;
  font-family: var(--font-Pretendard-Bold);
  color: var(--user-text);
`;

const EditButton = styled.div`
  border: 1.5px solid var(--user-border);
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 12px;
  color: var(--user-text-muted);
  cursor: pointer;
  font-family: var(--font-Pretendard-Medium);
  background-color: var(--user-surface);
  &:active {
    background-color: var(--user-surface-raised);
  }
`;

const ProfileEditButton = styled(EditButton)`
  position: absolute;
  right: 16px;
  flex-shrink: 0;
  min-height: 44px;
  white-space: nowrap;
  &:focus-visible { outline: 2px solid var(--user-accent); outline-offset: 2px; }
`;

const InfoCard = styled.div`
  width: 100%;
  padding: 8px 0px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const InfoRow = styled.div`
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr);
  column-gap: 12px;
  align-items: start;
  font-size: 14px;
  line-height: 22px;

  > .label {
    color: var(--user-text-muted);
    white-space: nowrap;
    font-family: var(--font-Pretendard-Medium);
  }
  > .value {
    min-width: 0;
    color: var(--user-text);
    font-family: var(--font-Pretendard-Bold);
    word-break: keep-all;
    overflow-wrap: anywhere;
  }
`;

const RequestNoteContent = styled.div`
  min-width: 0;
  .request-note-display { display: flex; align-items: flex-start; gap: 8px; }
  .request-note-display > span { flex: 1; min-width: 0; white-space: pre-wrap; }
  .request-note-actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 8px; }
  textarea { background: var(--user-surface); color: var(--user-text); }
  p { margin: 8px 0 0; font-size: 12px; font-weight: 400; color: var(--user-text-muted); }
  p[role="alert"] { color: var(--user-error); }
`;
const RequestNoteButton = styled.button`
  flex-shrink: 0;
  min-height: 44px;
  min-width: 44px;
  padding: 4px 12px;
  border: 1.5px solid var(--user-border);
  border-radius: 8px;
  background: var(--user-surface);
  color: var(--user-text);
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  &:focus-visible { outline: 2px solid var(--user-accent); outline-offset: 2px; }
  &:disabled { opacity: 0.6; cursor: wait; }
`;

const TrackingRow = styled(RowView)`
  align-items: center;
  justify-content: flex-start;
  font-size: 14px;
  color: var(--user-text);
  font-family: var(--font-Pretendard-Bold);
  gap: 6px;

  span.carrier {
    color: var(--user-text);
  }
  span.num {
    color: var(--user-text-muted);
    font-family: var(--font-Pretendard-Regular);
    margin-right: 4px;
  }
`;

const CopyBtnIcon = styled(Icon)`
  width: 16px;
  height: 16px;
  cursor: pointer;
  opacity: 0.7;
  &:hover {
    opacity: 1;
  }
`;

const TrackingExternal = styled.a`
  margin-left: auto;
  color: var(--user-accent);
  font-size: 12px;
  text-decoration: underline;
  white-space: nowrap;
`;

const EmptyPurchase = styled.p`
  display: flex; flex-direction: column; gap: 14px; align-items: center; justify-content: center; min-height: 160px;
  margin: 0; text-align: center; font-size: 14px; line-height: 1.5; color: var(--user-text-muted);
`;
const PurchaseCard = styled.div`
  width: 100%;
  display: flex; flex-direction: column; gap: 12px;
  box-sizing: border-box;
`;

const ProductGroup = styled.div`
  padding: 18px 16px;
  border: 1px solid var(--user-border); border-radius: 14px; background: var(--user-surface);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;

`;

const GroupHeader = styled(RowView)`
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 12px;
`;

const ProductName = styled.div`
  font-size: 15px;
  font-family: var(--font-Pretendard-Bold);
  color: var(--user-text);
  flex: 1;
  margin-right: 8px;
  word-break: break-all;
`;

const PurchaseClaimDetails = styled.div`
  display:grid;gap:10px;font-size:12px;line-height:1.6;color:var(--user-text-muted);
  p{margin:2px 0 0;overflow-wrap:anywhere;}
`;

const OptionRow = styled.div`
  font-size: 13px;
  color: var(--user-text-muted);
  font-family: var(--font-Pretendard-Regular);
  margin-bottom: 6px;
  padding-left: 8px;
`;

const ProductFooter = styled(RowView)`
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 14px; padding-top: 14px; border-top: 1px solid var(--user-border); gap: 12px; flex-wrap: wrap;

  .amount-row { display: flex; justify-content: space-between; align-items: center; gap: 12px; width: 100%; }
  div.qty {
    font-size: 13px;
    color: var(--user-text-muted);
    font-family: var(--font-Pretendard-Regular);
  }
  div.price {
    font-size: 16px;
    font-family: var(--font-Pretendard-Bold);
    color: var(--user-text);
  }
`;

const PriceSummary = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
`;

const SummaryRow = styled(RowView)`
  gap: 12px;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;

  div.label {
    color: var(--user-text-muted);
    font-family: var(--font-Pretendard-Medium);
  }
  div.value {
    flex-shrink: 0;
    white-space: nowrap;
    color: var(--user-text);
    font-family: var(--font-Pretendard-SemiBold);
  }
`;

const ExtraChargeBox = styled.div`
  width: 100%;
  padding: 12px;
  background-color: var(--user-surface-raised);
  border-radius: 8px;
  font-size: 12px;
  color: var(--user-text-muted);
  font-family: var(--font-Pretendard-Regular);
  margin-top: 12px;
  text-align: center;
  box-sizing: border-box;
`;

const FinalPayRow = styled(RowView)`
  justify-content: space-between;
  align-items: center;
  border-top: 1.5px solid #2d2d2d;
  padding-top: 16px;
  margin-top: 16px;

  div.label {
    font-size: 16px;
    font-family: var(--font-Pretendard-Medium);
    color: var(--user-text);
  }
  div.price {
    font-size: 20px;
    font-family: var(--font-Pretendard-Bold);
    color: var(--user-error);
  }
`;

const AgreeSection = styled.div<{ $attention: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 24px;
  border-top: 1px solid var(--user-border);
  padding-top: 20px;
  outline: ${props => props.$attention ? '2px solid var(--user-accent)' : 'none'};
  outline-offset: 8px;
  border-radius: 4px;
`;

const RemoteAreaBox = styled.div`
  display: grid; grid-template-columns: 1fr auto; gap: 12px; align-items: center;
  margin-top: 10px; padding: 14px; border: 1px solid var(--user-border); border-radius: 10px; background: var(--user-accent-soft);
  strong, span { display: block; }
  strong { margin-bottom: 4px; color: var(--user-text); font-size: 14px; }
  span { color: var(--user-text-muted); font-size: 12px; line-height: 1.45; }
  button { min-height: 44px; padding: 0 14px; border: 1px solid #6338dc; border-radius: 8px; background: var(--user-surface); color: var(--user-accent); cursor: pointer; }
  button[aria-pressed='true'] { background: #6338dc; color: #fff; }
  button:disabled { opacity: .6; cursor: default; }
  p { grid-column: 1 / -1; margin: 0; color: var(--user-error); font-size: 13px; }
  @media (max-width: 480px) { grid-template-columns: 1fr; button { width: 100%; } }
`;

const PaymentMethods = styled.fieldset`
  border: 1px solid var(--user-border); border-radius: 8px; margin: 24px 0 0; padding: 16px;
  legend { font-weight: 700; padding: 0 6px; }
  label { display: inline-flex; align-items: center; gap: 8px; margin-right: 20px; min-height: 36px; cursor: pointer; }
  input { accent-color: #4e12f9; width: 18px; height: 18px; }
`;

const AgreeItem = styled(RowView)`
  align-items: center;
  justify-content: space-between;
  width: 100%;

  label.left {
    position: relative;
    display: flex;
    min-height: 44px;
    cursor: pointer;
    input {
      position: absolute;
      width: 20px;
      height: 20px;
      margin: 0;
      opacity: 0;
      cursor: pointer;
    }
    input:focus + span {
      outline: 2px solid var(--user-accent);
      outline-offset: 3px;
    }
    align-items: center;
    gap: 10px;
    font-size: 14px;
    color: var(--user-text);
    font-family: var(--font-Pretendard-Medium);
    &.bold {
      font-family: var(--font-Pretendard-Bold);
      color: var(--user-text);
    }
  }
  .detail {
    font-size: 12px;
    color: var(--user-text-muted);
    cursor: pointer;
    font-family: var(--font-Pretendard-Regular);
    text-decoration: underline;
  }
`;

const CustomCheckbox = styled.span<{ $checked: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1.5px solid ${(props) => (props.$checked ? "var(--user-accent)" : "var(--user-border)")};
  background-color: ${(props) => (props.$checked ? "#4E12F9" : "transparent")};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-sizing: border-box;
  transition: all 0.15s ease;

  &:after {
    content: "";
    width: 5px;
    height: 9px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    margin-bottom: 2px;
    display: ${(props) => (props.$checked ? "block" : "none")};
  }
`;

const PaymentActionBar = styled.div`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 500px;
  box-sizing: border-box;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  background: var(--user-surface);
  border-top: 1px solid var(--user-border);
  z-index: 10;
  button { margin-top: 0; }
`;

const FooterPayButton = styled.button<{ $disabled: boolean }>`
  border: 0; display: flex; align-items: center; justify-content: center;
  background: ${(props) =>
    props.$disabled
      ? "var(--user-surface-raised)"
      : "linear-gradient(135deg, #7955F0, #3209B9)"};
  color: ${(props) => (props.$disabled ? "var(--user-text-muted)" : "white")};
  font-size: 18px;
  font-family: var(--font-Pretendard-Bold);
  width: 100%;
  height: 60px;
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};
  margin-top: 32px;
  border-radius: 8px;
  user-select: none;
`;

const EditInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
`;

const EditField = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  label {
    font-size: 14px;
    font-family: var(--font-Pretendard-Bold);
    color: var(--user-text);
    margin-bottom: 8px;
  }
`;

const InputText = styled.input`
  width: 100%;
  height: 48px;
  border: 1.5px solid var(--user-border);
  border-radius: 8px;
  padding: 0 16px;
  box-sizing: border-box;
  outline: none;
  font-size: 15px;
  font-family: var(--font-Pretendard-Regular);
  &:focus {
    border-color: #4e12f9;
  }
`;

const SearchRow = styled(RowView)`
  gap: 8px;
  width: 100%;
  margin-bottom: 8px;
`;

const SearchButton = styled(CenterView)`
  width: 80px;
  height: 48px;
  background-color: #2d2d2d;
  color: white;
  font-family: var(--font-Pretendard-Bold);
  font-size: 14px;
  border-radius: 8px;
  cursor: pointer;
  flex-shrink: 0;
`;

const TextareaRequest = styled.textarea`
  width: 100%;
  height: 120px;
  border: 1.5px solid var(--user-border);
  border-radius: 8px;
  padding: 12px 16px;
  box-sizing: border-box;
  outline: none;
  resize: none;
  font-size: 15px;
  font-family: var(--font-Pretendard-Regular);
  &:focus {
    border-color: #4e12f9;
  }
`;

const FooterSubmitButton = styled.button`
  border: 0; display: flex; align-items: center; justify-content: center;
  background: linear-gradient(135deg, #7955F0, #3209B9);
  color: white;
  font-size: 18px;
  font-family: var(--font-Pretendard-Bold);
  width: 100%;
  height: 60px;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 32px;
  user-select: none;
`;

const AlertOverlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  padding: 24px;
`;

const AlertBox = styled.div`
  background-color: var(--user-surface);
  border-radius: 16px;
  width: 100%;
  max-width: 320px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
`;

const AlertTitle = styled.div`
  font-size: 18px;
  font-family: var(--font-Pretendard-Bold);
  color: var(--user-text);
  margin-bottom: 16px;
  text-align: center;
`;

const AlertText = styled.div`
  font-size: 14px;
  color: var(--user-text);
  font-family: var(--font-Pretendard-Medium);
  line-height: 20px;
  text-align: center;
  margin-bottom: 24px;
  white-space: pre-wrap;
`;

const AlertButtonRow = styled(RowView)`
  width: 100%;
  gap: 8px;
`;

const AlertCancelBtn = styled(CenterView)`
  flex: 1;
  height: 48px;
  background-color: var(--user-surface-raised);
  color: var(--user-text-muted);
  font-family: var(--font-Pretendard-Bold);
  font-size: 15px;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;
`;

const AlertConfirmBtn = styled(CenterView)`
  flex: 1;
  height: 48px;
  background: linear-gradient(135deg, #7955F0, #3209B9);
  color: white;
  font-family: var(--font-Pretendard-Bold);
  font-size: 15px;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;
`;

const DetailLinkButton = styled(CenterView)`
  border: 1.5px solid var(--user-border);
  background-color: var(--user-surface);
  color: var(--user-text);
  font-size: 15px;
  font-family: var(--font-Pretendard-Bold);
  width: 100%;
  height: 52px;
  border-radius: 8px;
  cursor: pointer;
  margin-top: 16px;
  user-select: none;
  gap: 6px;
  box-sizing: border-box;

  span.arrow {
    font-size: 13px;
    color: var(--user-text-muted);
  }

  &:active {
    background-color: var(--user-surface-raised);
  }
`;

const SellerInquiryButton = styled(DetailLinkButton)`
  margin-top: 24px;
  flex-shrink: 0;
  &:focus-visible { outline: 2px solid var(--user-accent); outline-offset: 2px; }
`;

const PurchaseListButton = styled(DetailLinkButton)`
  justify-content: space-between;
  height: 56px;
  margin-top: 24px;
  padding: 0 18px;
  border: 1.5px solid var(--user-accent);
  background: var(--user-accent-soft);
  color: var(--user-text);
  font-size: 16px;
  border-radius: 10px;
  svg { flex-shrink: 0; color: var(--user-accent); }
  &:hover, &:active { background: var(--user-surface-raised); }
  &:focus-visible { outline: 2px solid var(--user-accent); outline-offset: 3px; }
`;

const CancellationHistory = styled.section`
  margin: 0; flex: none; padding: 8px 0 16px; color: var(--user-text);
  h2 { margin: 0 0 12px; font-size: 15px; color: var(--user-text-muted); }
  section { margin-bottom: 12px; padding: 18px 16px; border: 1px solid var(--user-border); border-radius: 14px; }
  .cancellation-heading { display:flex; flex-direction:column; align-items:flex-start; gap:10px; }
  .cancel-status { display:inline-flex; align-items:center; gap:6px; padding:5px 8px; border-radius:6px; background:var(--user-surface-raised); font-size:12px; color:var(--user-text-muted); }
  p { margin: 14px 0; font-size: 15px; line-height:1.6; overflow-wrap: anywhere; }
  .refund-status { display:inline-block; margin:12px 0 0; color:var(--user-accent); font-size:13px; }
  span { color: var(--user-text-muted); font-size: 13px; line-height:1.6; overflow-wrap:anywhere; font-variant-numeric:tabular-nums; }
  .cancel-amount { display:block; padding-top:12px; border-top:1px solid var(--user-border); text-align:right; font:18px var(--font-Pretendard-SemiBold); color:var(--user-text); }
`;

const CashReceiptStatus = styled.section<{ $issued: boolean }>`
  display:flex;align-items:center;gap:12px;margin:16px 0 0;padding:16px;border:1px solid var(--user-border);border-radius:14px;
  .receipt-icon{display:grid;place-items:center;flex-shrink:0;width:42px;height:42px;border-radius:12px;background:var(--user-accent-soft);color:var(--user-accent);}
  >div{flex:1;min-width:0;}
  .receipt-heading{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:8px;font-size:14px;line-height:1.5;}
  strong{padding:4px 9px;border-radius:6px;background:${({ $issued }) => $issued ? 'var(--user-accent-soft)' : 'var(--user-surface-raised)'};color:${({ $issued }) => $issued ? 'var(--user-accent)' : 'var(--user-text-muted)'};font-size:12px;}
  .receipt-number{display:block;margin-top:8px;font-size:12px;line-height:1.5;color:var(--user-text-muted);overflow-wrap:anywhere;}
`;

const ProductCoupon = styled.div`display: flex; justify-content: space-between; gap: 12px; margin-top: 12px; padding: 10px 12px; border-radius: 8px; background: var(--user-accent-soft); color: var(--user-accent, #7954ee); font-size: 13px;`;
